export const Features = {
    /** GLOBAL * */
    PIPELINE_AUTOMATIONS: "pipelineAutomations",
    /**
     * Search filters
     */
    SEARCH_FILTER_SEARCH_OUTSIDE_CASELOAD: "searchOutsideCaseload",
    SEARCH_FILTER_FOLLOWERS_ONLY: "searchFollowersOnly",
    SEARCH_FILTER_CITY: "searchCity",
    SEARCH_FILTER_STATE: "searchState",
    SEARCH_FILTER_ZIP: "searchZip",
    SEARCH_FILTER_INCLUDE_TAGS: "searchFilterIncludeTags",
    SEARCH_FILTER_EXCLUDE_TAGS: "searchFilterExcludeTags",
    SEARCH_FILTER_MINORITY: "searchFilterMinority",
    SEARCH_FILTER_INCLUDE_RACE: "searchFilterIncludeRaces",
    SEARCH_FILTER_EXCLUDE_RACE: "searchFilterExcludeRaces",
    SEARCH_FILTER_INCLUDE_ETHNICITIES: "searchFilterIncludeEthnicities",
    SEARCH_FILTER_EXCLUDE_ETHNICITIES: "searchFilterExcludeEthnicities",
    SEARCH_FILTER_AGE: "searchFilterAge",
    SEARCH_FILTER_GENDER: "searchFilterGender",
    SEARCH_FILTER_CAMPUS: "searchFilterCampus",
    SEARCH_FILTER_COURSE_RISK_LEVEL: "searchCourseRisk",
    SEARCH_FILTER_PERSISTENCE_RISK_LEVEL: "searchPersistenceRisk",
    SEARCH_FILTER_HAS_OPEN_ALERTS: "searchOpenAlerts",
    SEARCH_FILTER_INCLUDE_DEGREES: "searchFilterIncludeDegrees",
    SEARCH_FILTER_EXCLUDE_DEGREES: "searchFilterExcludeDegrees",
    SEARCH_FILTER_INCLUDE_PROGRAMS: "searchFilterIncludePrograms",
    SEARCH_FILTER_EXCLUDE_PROGRAMS: "searchFilterExcludePrograms",
    SEARCH_FILTER_INCLUDE_MAJORS: "searchFilterIncludeMajors",
    SEARCH_FILTER_EXCLUDE_MAJORS: "searchFilterExcludeMajors",
    SEARCH_FILTER_INCLUDE_MINORS: "searchFilterIncludeMinors",
    SEARCH_FILTER_EXCLUDE_MINORS: "searchFilterExcludeMinors",
    SEARCH_FILTER_INCLUDE_CONCENTRATIONS: "searchFilterIncludeConcentrations",
    SEARCH_FILTER_EXCLUDE_CONCENTRATIONS: "searchFilterExcludeConcentrations",
    SEARCH_FILTER_INCLUDE_SPECIALIZATIONS: "searchFilterIncludeSpecializations",
    SEARCH_FILTER_EXCLUDE_SPECIALIZATIONS: "searchFilterExcludeSpecializations",
    SEARCH_FILTER_INCLUDE_REGISTRATION_TERMS: "searchFilterIncludeRegistrationTerms",
    SEARCH_FILTER_EXCLUDE_REGISTRATION_TERMS: "searchFilterExcludeRegistrationTerms",
    SEARCH_FILTER_INCLUDE_HOLDS: "searchFilterIncludeHolds",
    SEARCH_FILTER_EXCLUDE_HOLDS: "searchFilterExcludeHolds",
    SEARCH_FILTER_LAST_KE: "searchFilterLastKE",
    SEARCH_FILTER_MAJOR_GPA: "searchFilterMajorGpa",
    SEARCH_FILTER_CUMULATIVE_GPA: "searchFilterCumulativeGpa",
    SEARCH_FILTER_INCLUDE_STUDENT_TYPES: "searchFilterIncludeStudentTypes",
    SEARCH_FILTER_EXCLUDE_STUDENT_TYPES: "searchFilterExcludeStudentTypes",
    SEARCH_FILTER_INCLUDE_STUDENT_STATUSES: "searchFilterIncludeStudentStatuses",
    SEARCH_FILTER_EXCLUDE_STUDENT_STATUSES: "searchFilterExcludeStudentStatuses",
    SEARCH_FILTER_STUDENT_LIST: "searchFilterStudentList",
    SEARCH_FILTER_ADVISOR: "searchFilterAdvisor",
    SEARCH_FILTER_COACH: "searchFilterCoach",
    SEARCH_FILTER_TERMS: "searchFilterTerms",
    SEARCH_FILTER_COURSES: "searchFilterCourses",
    SEARCH_FILTER_COURSE_SECTIONS: "searchFilterCourseSections",
    SEARCH_FILTER_INCLUDE_HIGH_SCHOOL: "searchFilterIncludeHighSchools",
    SEARCH_FILTER_EXCLUDE_HIGH_SCHOOL: "searchFilterExcludeHighSchools",
    SEARCH_FILTER_HS_START: "searchFilterHsStart",
    SEARCH_FILTER_HS_END: "searchFilterHsEnd",
    SEARCH_FILTER_HS_GPA: "searchFilterHsGpa",
    SEARCH_FILTER_HS_TRANSCRIPT_DATE: "searchFilterHsTranscriptDate",
    SEARCH_FILTER_INCLUDE_HS_TRANSCRIPT_STATUS: "searchFilterIncludeHsTranscriptStatus",
    SEARCH_FILTER_EXCLUDE_HS_TRANSCRIPT_STATUS: "searchFilterExcludeHsTranscriptStatus",
    SEARCH_FILTER_INCLUDE_HS_TRANSCRIPT_TYPE: "searchFilterIncludeHsTranscriptType",
    SEARCH_FILTER_EXCLUDE_HS_TRANSCRIPT_TYPE: "searchFilterExcludeHsTranscriptType",
    SEARCH_FILTER_HS_YEAR_ATTENDED: "searchFilterHsYearAttended",
    SEARCH_FILTER_INCLUDE_HS_GRADUATION_TYPE: "searchFilterIncludeHsGraduationType",
    SEARCH_FILTER_EXCLUDE_HS_GRADUATION_TYPE: "searchFilterExcludeHsGraduationType",
    SEARCH_FILTER_INCLUDE_APPLICATION_LOAD_INTENT: "searchFilterIncludeApplicationLoadIntent",
    SEARCH_FILTER_EXCLUDE_APPLICATION_LOAD_INTENT: "searchFilterExcludeApplicationLoadIntent",
    SEARCH_FILTER_INCLUDE_APPLICATION_RESIDENCY_STATUS: "searchFilterIncludeApplicationResidencyStatus",
    SEARCH_FILTER_EXCLUDE_APPLICATION_RESIDENCY_STATUS: "searchFilterExcludeApplicationResidencyStatus",
    SEARCH_FILTER_INCLUDE_APPLICATION_ADMIT_STATUS: "searchFilterIncludeApplicationAdmitStatus",
    SEARCH_FILTER_EXCLUDE_APPLICATION_ADMIT_STATUS: "searchFilterIncludeApplicationAdmitStatus",
    SEARCH_FILTER_INCLUDE_APPLICATION_STUDENT_TYPE: "searchFilterIncludeApplicationStudentType",
    SEARCH_FILTER_EXCLUDE_APPLICATION_STUDENT_TYPE: "searchFilterExcludeApplicationStudentType",
    SEARCH_FILTER_INCLUDE_APPLICATION_LOCATIONS: "searchFilterIncludeApplicationLocations",
    SEARCH_FILTER_EXCLUDE_APPLICATION_LOCATIONS: "searchFilterExcludeApplicationLocations",
    SEARCH_FILTER_APPLICATION_STATUS: "searchFilterApplicationStatus",
    SEARCH_FILTER_APPLICATION_TERMS: "searchFilterApplicationTerms",
    SEARCH_FILTER_INCLUDE_APPLICATION_TYPES: "searchFilterIncludeApplicationTypes",
    SEARCH_FILTER_EXCLUDE_APPLICATION_TYPES: "searchFilterExcludeApplicationTypes",
    SEARCH_FILTER_APPLICATION_AGE: "searchFilterApplicationAge",
    SEARCH_FILTER_VETERAN: "searchFilterVeteran",
    SEARCH_FILTER_FIRST_GEN: "searchFilterFirstGen",
    SEARCH_FILTER_CUMULATIVE_CREDIT_HOURS: "searchFilterCumulativeCreditHours",
    SEARCH_FILTER_ANTICIPATED_GRADUATION_DATE: "searchFilterAnticipatedGraduationDate",
    SEARCH_FILTER_LAST_ASSIGNMENT_SUBMITTED_DAYS: "searchFilterLastAssignmentSubmittedDays",
    SEARCH_FILTER_IMPORT_PROCESS_CSV: "searchFilterImportProcessCsv",
    SEARCH_FILTER_PIPELINES: "searchFilterPipelines",
    SEARCH_FILTER_INCLUDE_INTENDED_START_TERM: "searchFilterIncludeIntendedStartTerm",
    SEARCH_FILTER_EXCLUDE_INTENDED_START_TERM: "searchFilterExcludeIntendedStartTerm",
    SEARCH_FILTER_INCLUDE_PROGRAM_INTEREST: "searchFilterIncludeInterestedPrograms",
    SEARCH_FILTER_EXCLUDE_PROGRAM_INTEREST: "searchFilterExcludeInterestedPrograms",
    SEARCH_FILTER_INCLUDE_DEPARTMENT_INTEREST: "searchFilterIncludeInterestedDepartments",
    SEARCH_FILTER_EXCLUDE_DEPARTMENT_INTEREST: "searchFilterExcludeInterestedDepartments",
    SEARCH_FILTER_DAYS_SINCE_SUBMITTED_FORM: "searchFilterDaysSinceSubmittedForm",
    SEARCH_FILTER_INCLUDE_SUBMITTED_FORMS: "searchFilterSubmittedFormsInclude",
    SEARCH_FILTER_EXCLUDE_SUBMITTED_FORMS: "searchFilterSubmittedFormsExclude",
    SEARCH_FILTER_INCLUDE_SUBMITTED_FORM_ANSWER_INTENDED_START_TERM: "searchFilterSubmittedFormsIntendedStartTermsInclude",
    SEARCH_FILTER_EXCLUDE_SUBMITTED_FORM_ANSWER_INTENDED_START_TERM: "searchFilterSubmittedFormsIntendedStartTermsExclude",
    SEARCH_FILTER_INCLUDE_SUBMITTED_FORM_ANSWER_PROGRAM_INTEREST: "searchFilterSubmittedFormsInterestedProgramsInclude",
    SEARCH_FILTER_EXCLUDE_SUBMITTED_FORM_ANSWER_PROGRAM_INTEREST: "searchFilterSubmittedFormsInterestedProgramsExclude",
    SEARCH_FILTER_INCLUDE_SUBMITTED_FORM_ANSWER_DEPARTMENT_INTEREST: "searchFilterSubmittedFormsDepartmentInterestsInclude",
    SEARCH_FILTER_EXCLUDE_SUBMITTED_FORM_ANSWER_DEPARTMENT_INTEREST: "searchFilterSubmittedFormsDepartmentInterestsExclude",
    SEARCH_FILTER_INCLUDE_PROSPECT_SOURCE: "searchFilterProspectSourceIncludes",
    SEARCH_FILTER_EXCLUDE_PROSPECT_SOURCE: "searchFilterProspectSourceExcludes",
    /**
     * Filter actions
     */
    FILTER_EDIT: "filterEdit",
    FILTER_COPY: "filterCopy",
    FILTER_DELETE: "filterDelete",
    FILTER_TO_EXCEL: "filterToExcel",
    FILTER_BULK_ACTION_MESSAGE: "filterBulkMessage",
    FILTER_BULK_ACTION_ALERT: "filterBulkAlert",
    FILTER_BULK_ACTION_NOTE: "filterBulkNote",
    FILTER_BULK_ACTION_SURVEY: "filterBulkSurvey",
    FILTER_BULK_ACTION_TASK: "filterBulkTask",
    FILTER_BULK_ACTION_PLAN: "filterBulkActionPlan",
    FILTER_BULK_SEND_TO_CAMPAIGN: "filterBulkSendCampaign",
    FILTER_BULK_SEND_TO_PIPELINE: "pipelineEnrollFilter",
    /**
     * Tabs
     */
    PROFILE_PROFILE: "Profile",
    PROFILE_ACTIVITY: "Activity",
    PROFILE_ALERTS: "Alerts",
    PROFILE_NOTES: "Notes",
    PROFILE_TASKS: "Tasks",
    PROFILE_SURVEYS: "Surveys",
    PROFILE_MEETINGS: "Meetings",
    PROFILE_COURSES: "Courses",
    PROFILE_TRANSCRIPT: "Transcript",
    PROFILE_TEST_SCORES: "TestScores",
    PROFILE_FINANCES: "Finances",
    PROFILE_APPLICATIONS: "Applications",
    PROFILE_MESSAGES: "Messages",
    PROFILE_DOCS: "Docs",
    PROFILE_PROGRAMS: "Programs",
    PROFILE_ANALYTICS: "Analytics",
    PROFILE_PHONECALLS: "PhoneCall",
    PROFILE_PIPELINES: "Pipeline",
    PROFILE_FORMS: "Forms",
    PROFILE_SEND_MESSAGE: "profileSendMessage",
    PROFILE_ADD_NOTE: "profileAddNote",
    PROFILE_FOLLOW_TOGGLE: "profileFollowToggle",
    PROFILE_ADD_ALERT: "profileAddAlert",
    PROFILE_EXCUSED_ABSENCE: "profileExcusedAbsence",
    PROFILE_SHARE_RESOURCE: "profileShareResource",
    PROFILE_ADD_TO_PIPELINE: "profileEnrollInPipeline",
    /**
     * Profile Features
     */
    PROFILE_SHOW_ADVISOR: "profileShowAdvisor",
    PROFILE_SHOW_COACH: "profileShowCoach",
    PROFILE_SHOW_FOLLOWERS: "profileShowFollowers",
    PROFILE_TAB_SHOW_INTENDED_PROGRAMS: "profileTabShowIntendedPrograms",
    PROFILE_TAB_SHOW_INTENDED_TERMS: "profileTabShowIntendedTerms",
    PROFILE_TAB_SHOW_INTERESTED_DEPARTMENTS: "profileTabShowInterestedDepartments",
    PROFILE_TAB_SHOW_PROSPECT_SOURCE: "profileTabShowProspectSource",
    /**
     *Campaign Types
     */
    APPOINTMENT_CAMPAIGNS: "appointmentCampaigns",
    APPLICATION_CAMPAIGNS: "applicationCampaigns",
    ENROLLMENT_CAMPAIGNS: "enrollmentCampaigns",
    /**
     * Other features
     */
    ACADEMIC_PLAN_VIEW_ACADEMIC_PLAN: "viewAcademicPlan",
    INDICATORS_COURSE_RISK_INDICATOR: "courseRiskIndicator",
    INDICATORS_PERSISTENCE_RISK_INDICATOR: "persistenceRiskIndicator",
    /**
     * Analytics Tab Graphs
     */
    GRAPH_STUDENT_COUNT: "graphStudentCount",
    GRAPH_TASKS: "graphTasks",
    GRAPH_PERSISTENCE_RISK: "graphPersistenceRisk",
    GRAPH_COURSE_RISK: "graphCourseRisk",
    GRAPH_APPOINTMENTS: "graphAppointments",
    GRAPH_GPA: "graphGPA",
    GRAPH_CREDITS: "graphCredits",
    /**
     * Meeting Scheduler
     */
    NEW_SCHEDULER_ENABLED: "newScheduler",
};
export const FeatureGroups = {
    GENERAL_INFORMATION: [
        Features.SEARCH_FILTER_CITY,
        Features.SEARCH_FILTER_STATE,
        Features.SEARCH_FILTER_ZIP,
    ],
    TAGS: [
        Features.SEARCH_FILTER_INCLUDE_TAGS,
        Features.SEARCH_FILTER_EXCLUDE_TAGS,
    ],
    DEMOGRAPHICS: [
        Features.SEARCH_FILTER_MINORITY,
        Features.SEARCH_FILTER_INCLUDE_RACE,
        Features.SEARCH_FILTER_EXCLUDE_RACE,
        Features.SEARCH_FILTER_INCLUDE_ETHNICITIES,
        Features.SEARCH_FILTER_EXCLUDE_ETHNICITIES,
        Features.SEARCH_FILTER_AGE,
        Features.SEARCH_FILTER_GENDER,
    ],
    STUDENT_INFORMATION: [
        Features.SEARCH_FILTER_CAMPUS,
        Features.SEARCH_FILTER_COURSE_RISK_LEVEL,
        Features.SEARCH_FILTER_PERSISTENCE_RISK_LEVEL,
        Features.SEARCH_FILTER_HAS_OPEN_ALERTS,
        Features.SEARCH_FILTER_INCLUDE_DEGREES,
        Features.SEARCH_FILTER_EXCLUDE_DEGREES,
        Features.SEARCH_FILTER_INCLUDE_PROGRAMS,
        Features.SEARCH_FILTER_EXCLUDE_PROGRAMS,
        Features.SEARCH_FILTER_INCLUDE_REGISTRATION_TERMS,
        Features.SEARCH_FILTER_EXCLUDE_REGISTRATION_TERMS,
        Features.SEARCH_FILTER_INCLUDE_HOLDS,
        Features.SEARCH_FILTER_EXCLUDE_HOLDS,
        Features.SEARCH_FILTER_LAST_KE,
        Features.SEARCH_FILTER_MAJOR_GPA,
        Features.SEARCH_FILTER_CUMULATIVE_GPA,
        Features.SEARCH_FILTER_INCLUDE_STUDENT_TYPES,
        Features.SEARCH_FILTER_EXCLUDE_STUDENT_TYPES,
        Features.SEARCH_FILTER_INCLUDE_STUDENT_STATUSES,
        Features.SEARCH_FILTER_EXCLUDE_STUDENT_STATUSES,
        Features.SEARCH_FILTER_STUDENT_LIST,
        Features.SEARCH_FILTER_CUMULATIVE_CREDIT_HOURS,
        Features.SEARCH_FILTER_ANTICIPATED_GRADUATION_DATE,
        Features.SEARCH_FILTER_LAST_ASSIGNMENT_SUBMITTED_DAYS,
        Features.SEARCH_FILTER_INCLUDE_INTENDED_START_TERM,
        Features.SEARCH_FILTER_EXCLUDE_INTENDED_START_TERM,
        Features.SEARCH_FILTER_INCLUDE_PROGRAM_INTEREST,
        Features.SEARCH_FILTER_EXCLUDE_PROGRAM_INTEREST,
        Features.SEARCH_FILTER_INCLUDE_DEPARTMENT_INTEREST,
        Features.SEARCH_FILTER_EXCLUDE_DEPARTMENT_INTEREST,
        Features.SEARCH_FILTER_INCLUDE_PROSPECT_SOURCE,
        Features.SEARCH_FILTER_EXCLUDE_PROSPECT_SOURCE,
    ],
    CURRICULUM: [
        Features.SEARCH_FILTER_INCLUDE_MAJORS,
        Features.SEARCH_FILTER_EXCLUDE_MAJORS,
        Features.SEARCH_FILTER_INCLUDE_MINORS,
        Features.SEARCH_FILTER_EXCLUDE_MINORS,
        Features.SEARCH_FILTER_INCLUDE_CONCENTRATIONS,
        Features.SEARCH_FILTER_EXCLUDE_CONCENTRATIONS,
        Features.SEARCH_FILTER_INCLUDE_SPECIALIZATIONS,
        Features.SEARCH_FILTER_EXCLUDE_SPECIALIZATIONS,
    ],
    SUCCESS_TEAM: [Features.SEARCH_FILTER_ADVISOR, Features.SEARCH_FILTER_COACH],
    COURSES_AND_SECTIONS: [
        Features.SEARCH_FILTER_TERMS,
        Features.SEARCH_FILTER_COURSES,
        Features.SEARCH_FILTER_COURSE_SECTIONS,
    ],
    HIGH_SCHOOL: [
        Features.SEARCH_FILTER_INCLUDE_HIGH_SCHOOL,
        Features.SEARCH_FILTER_EXCLUDE_HIGH_SCHOOL,
        Features.SEARCH_FILTER_HS_START,
        Features.SEARCH_FILTER_HS_END,
        Features.SEARCH_FILTER_HS_GPA,
        Features.SEARCH_FILTER_HS_TRANSCRIPT_DATE,
        Features.SEARCH_FILTER_INCLUDE_HS_TRANSCRIPT_STATUS,
        Features.SEARCH_FILTER_EXCLUDE_HS_TRANSCRIPT_STATUS,
        Features.SEARCH_FILTER_INCLUDE_HS_TRANSCRIPT_TYPE,
        Features.SEARCH_FILTER_EXCLUDE_HS_TRANSCRIPT_TYPE,
        Features.SEARCH_FILTER_HS_YEAR_ATTENDED,
        Features.SEARCH_FILTER_INCLUDE_HS_GRADUATION_TYPE,
        Features.SEARCH_FILTER_EXCLUDE_HS_GRADUATION_TYPE,
    ],
    APPLICATION: [
        Features.SEARCH_FILTER_APPLICATION_STATUS,
        Features.SEARCH_FILTER_APPLICATION_TERMS,
        Features.SEARCH_FILTER_INCLUDE_APPLICATION_TYPES,
        Features.SEARCH_FILTER_EXCLUDE_APPLICATION_TYPES,
        Features.SEARCH_FILTER_APPLICATION_AGE,
        Features.SEARCH_FILTER_INCLUDE_APPLICATION_LOAD_INTENT,
        Features.SEARCH_FILTER_EXCLUDE_APPLICATION_LOAD_INTENT,
        Features.SEARCH_FILTER_INCLUDE_APPLICATION_RESIDENCY_STATUS,
        Features.SEARCH_FILTER_EXCLUDE_APPLICATION_RESIDENCY_STATUS,
        Features.SEARCH_FILTER_INCLUDE_APPLICATION_ADMIT_STATUS,
        Features.SEARCH_FILTER_EXCLUDE_APPLICATION_ADMIT_STATUS,
        // @ts-expect-error - TS2551 - Property 'SEARCH_FILTER_INCLUDE_APPLICATION_START_TERM' does not exist on type '{ readonly PIPELINE_AUTOMATIONS: "pipelineAutomations"; readonly SEARCH_FILTER_SEARCH_OUTSIDE_CASELOAD: "searchOutsideCaseload"; readonly SEARCH_FILTER_FOLLOWERS_ONLY: "searchFollowersOnly"; ... 138 more ...; readonly GRAPH_CREDITS: "graphCredits"; }'. Did you mean 'SEARCH_FILTER_INCLUDE_APPLICATION_STUDENT_TYPE'?
        Features.SEARCH_FILTER_INCLUDE_APPLICATION_START_TERM,
        // @ts-expect-error - TS2551 - Property 'SEARCH_FILTER_EXCLUDE_APPLICATION_START_TERM' does not exist on type '{ readonly PIPELINE_AUTOMATIONS: "pipelineAutomations"; readonly SEARCH_FILTER_SEARCH_OUTSIDE_CASELOAD: "searchOutsideCaseload"; readonly SEARCH_FILTER_FOLLOWERS_ONLY: "searchFollowersOnly"; ... 138 more ...; readonly GRAPH_CREDITS: "graphCredits"; }'. Did you mean 'SEARCH_FILTER_EXCLUDE_APPLICATION_STUDENT_TYPE'?
        Features.SEARCH_FILTER_EXCLUDE_APPLICATION_START_TERM,
        Features.SEARCH_FILTER_INCLUDE_APPLICATION_STUDENT_TYPE,
        Features.SEARCH_FILTER_EXCLUDE_APPLICATION_STUDENT_TYPE,
        Features.SEARCH_FILTER_INCLUDE_APPLICATION_LOCATIONS,
        Features.SEARCH_FILTER_EXCLUDE_APPLICATION_LOCATIONS,
    ],
    CAMPAIGN_TYPES: [
        Features.APPOINTMENT_CAMPAIGNS,
        Features.APPLICATION_CAMPAIGNS,
        Features.ENROLLMENT_CAMPAIGNS,
    ],
    IMPORT: [Features.SEARCH_FILTER_IMPORT_PROCESS_CSV],
    PIPELINES: [Features.SEARCH_FILTER_PIPELINES],
    FORMS: [
        Features.SEARCH_FILTER_DAYS_SINCE_SUBMITTED_FORM,
        Features.SEARCH_FILTER_INCLUDE_SUBMITTED_FORMS,
        Features.SEARCH_FILTER_INCLUDE_SUBMITTED_FORM_ANSWER_INTENDED_START_TERM,
        Features.SEARCH_FILTER_EXCLUDE_SUBMITTED_FORM_ANSWER_INTENDED_START_TERM,
        Features.SEARCH_FILTER_INCLUDE_SUBMITTED_FORM_ANSWER_PROGRAM_INTEREST,
        Features.SEARCH_FILTER_EXCLUDE_SUBMITTED_FORM_ANSWER_PROGRAM_INTEREST,
        Features.SEARCH_FILTER_INCLUDE_SUBMITTED_FORM_ANSWER_DEPARTMENT_INTEREST,
        Features.SEARCH_FILTER_EXCLUDE_SUBMITTED_FORM_ANSWER_DEPARTMENT_INTEREST,
    ],
    MEETING_SCHEDULER: [Features.NEW_SCHEDULER_ENABLED],
};
